import DialogConfirmCancel from '../../../../dialog/DialogConfirm';
import SurveyTemplatePreview from '../../Templates/SurveyTemplatePreview/SurveyTemplatePreview';

const SurveyTemplateDialog = ({
  id,
  open,
  loading = false,
  onCancel,
  onConfirm,
  textCancel = 'Cancel',
  textConfirm = 'Confirm',
  disabledContent = true,
  title,
  maxWidth = 'sm',
  onCloseHeader,
  showActions = true,
  questions = []
}) => {
  return (
    <DialogConfirmCancel
      id={id}
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      loading={loading}
      title={title || 'Template Preview'}
      onCloseHeader={onCloseHeader}
      maxWidth={maxWidth}
      textConfirm={textConfirm}
      textCancel={textCancel}
      showActions={showActions}
    >
      <SurveyTemplatePreview
        questions={questions?.map((item) => {
          return {
            ...item,
            error: null
          };
        })}
        disabled={disabledContent}
      />
    </DialogConfirmCancel>
  );
};

export default SurveyTemplateDialog;
